import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'categories-results_screen-view';

/**
 * An event fired when the user lands on a category results page. Does not necessarily mean the content has loaded, simply fired upon landing on the screen.
 */
export function trackCategoriesResultsScreenView(
  navLinkIdentifier: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { navLinkIdentifier },
  });
}
